
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqKiXQfblq22I423T_zsYYD59mLnRPaySepNtFcfmttmIMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/faq.vue?macro=true";
import { default as about3ru6aTiAV0fmDwG6kv8WtKUTwOD270P4P4j3uIqJc04Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/about.vue?macro=true";
import { default as offerXnPQQceQH9uqrOtZPFu2UB1fhP1c3kmccvjvXzbSup4Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/offer.vue?macro=true";
import { default as privacyWvZbM_FeT4KUXJpx7buSMek0Sj7N3ph53ZuI1ND3_9kMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/privacy.vue?macro=true";
import { default as returnshluqP3Jdnel4aMT9ZFLRBom_KwpDqEr_0UC6_b0es14Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/returns.vue?macro=true";
import { default as agreementECt0A04d5AzH09jLIrkSTmaKXC7p7_mnZC5eIZG80rYMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/agreement.vue?macro=true";
import { default as indexGkpQemevHd80Zjl50eZeHjEWR_YgdTm6QNmiGyw2AIgMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/index.vue?macro=true";
import { default as indexigltp3AO1pRVt5Yb_xrIbGR0OKN2TtHD79fWesnRr3UMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Cart/pages/cart/index.vue?macro=true";
import { default as indexo1dPulheVZKgzBpaRtZhHCOx4EAZKWmFu5YXmY3R2e0Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/index.vue?macro=true";
import { default as _91slug_931keRg2ueHea_fHQgj9r85jVbp4Ogfeo49vAc9XaVEv0Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/[slug].vue?macro=true";
import { default as _91slug_93VnKbrhN3sZ08fFxAC_CZxlTP3NqAU4GE37TYmBhRKUYMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/[slug].vue?macro=true";
import { default as indexlGa5XNEyU8_TJn44k2bvLWUeZQoeFrPIFdzj8wB4EeAMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/index.vue?macro=true";
import { default as _91slug_93HlrFrwK9oexiTPd3RJiXf2eX_RB4e9LbzmKxQSyxCF8Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/pages/[slug].vue?macro=true";
import { default as _91id_93Q5cJFfLxlzHfFjpAytvHLCLJn9MLXQy13_exNWmq01MMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/product/[id].vue?macro=true";
import { default as index5pVctHygG6nDma_cBsALpfDda2gjf9o_d60G_ysq6YcMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/search/index.vue?macro=true";
import { default as data_45transfer1lMyI5zKUy9Exy8dOQi9Yopzn7k3DSzsTNVc164mEB4Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/data-transfer.vue?macro=true";
import { default as indexsSsw_KtkVI_XBw2AexCl0eeoBt45BI4hgdeDu5QwskUMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/index.vue?macro=true";
import { default as _91tab_93ZDnQA_kGQ7n4x_AwglBbBPWdCp2WvZTZDKE3Am2OST4Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders/[tab].vue?macro=true";
import { default as OrdersLgQK5ctJq61Gfjh58xFQWZxUYbLzM0SXKxpxOICZRMcMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders.vue?macro=true";
import { default as _91id_93I7fPXHF4bZubbuWkazO_gBgoqslGxPG3xlr9NYf1lyEMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Detail/[id].vue?macro=true";
import { default as indexIzVQ3GHwZC54k3XOO7RTsi9nV__Rr63x_F9mb_sHNygMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/[[category]]/index.vue?macro=true";
import { default as indexXLqCkOMyLbwS2EAthiN3XnrH75STI824TD7z3qKcYFcMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Create/index.vue?macro=true";
import { default as indexeoS3Au7tNl4lCL_1qAbnYwrePbwWLYY4GL6oshPoAz8Meta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/Edit/index.vue?macro=true";
import { default as indexJwQckVpGWxrI1rMkx5xLgulxHKW2VVEXexuKHJf_nwQMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Loyalty/pages/Profile/Loyalty/index.vue?macro=true";
import { default as indexyOgbI1hORu_m_ZUHYmProVUINWFJvDxFWFUjd4yXElsMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Favorites/pages/Profile/Favorites/index.vue?macro=true";
import { default as indexB9hvkhnD_IryY9c1wlUGZxU_g7ia8BQojURLYrAPpUsMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Fail/index.vue?macro=true";
import { default as indexLCm5rRrY1JEcCog13VXX8D5MJXObF2fsYZQBBK9ZNqYMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/catalog/[[category]]/index.vue?macro=true";
import { default as indexfHJCzPVA1TYy6OS754wqSLqOltQAt0LkDwn96IolEsAMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Success/index.vue?macro=true";
import { default as indexJsVg1vY1vlIFlD_zWf9ash15FtT_ZFrM_cgYtaUROXkMeta } from "/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Notifications/pages/Profile/Notifications/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/faq.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/about.vue")
  },
  {
    name: "offer",
    path: "/offer",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/offer.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/privacy.vue")
  },
  {
    name: "returns",
    path: "/returns",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/returns.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/agreement.vue")
  },
  {
    name: "BlogIndex",
    path: "/blog",
    meta: indexGkpQemevHd80Zjl50eZeHjEWR_YgdTm6QNmiGyw2AIgMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/index.vue")
  },
  {
    name: "CartIndex",
    path: "/cart",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Cart/pages/cart/index.vue")
  },
  {
    name: "NewsIndex",
    path: "/news",
    meta: indexo1dPulheVZKgzBpaRtZhHCOx4EAZKWmFu5YXmY3R2e0Meta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/index.vue")
  },
  {
    name: "BlogDetails",
    path: "/blog/:slug()",
    meta: _91slug_931keRg2ueHea_fHQgj9r85jVbp4Ogfeo49vAc9XaVEv0Meta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/blog/[slug].vue")
  },
  {
    name: "NewsDetails",
    path: "/news/:slug()",
    meta: _91slug_93VnKbrhN3sZ08fFxAC_CZxlTP3NqAU4GE37TYmBhRKUYMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/news/[slug].vue")
  },
  {
    name: "OrderIndex",
    path: "/Order",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/index.vue")
  },
  {
    name: "ContentPageDetails",
    path: "/pages/:slug()",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Content/pages/pages/[slug].vue")
  },
  {
    name: "ProductsDetails",
    path: "/product/:id()",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/product/[id].vue")
  },
  {
    name: "ProductsSearch",
    path: "/search",
    meta: index5pVctHygG6nDma_cBsALpfDda2gjf9o_d60G_ysq6YcMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/search/index.vue")
  },
  {
    name: "data-transfer",
    path: "/data-transfer",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Info/pages/data-transfer.vue")
  },
  {
    name: "ProfileIndex",
    path: "/Profile",
    meta: { ...(indexsSsw_KtkVI_XBw2AexCl0eeoBt45BI4hgdeDu5QwskUMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/index.vue")
  },
  {
    name: "Profile-Orders",
    path: "/Profile/Orders",
    redirect: "/profile/orders/active",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders.vue"),
    children: [
  {
    name: "ProfileOrdersTab",
    path: ":tab()",
    meta: { ...(_91tab_93ZDnQA_kGQ7n4x_AwglBbBPWdCp2WvZTZDKE3Am2OST4Meta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Profile/Orders/[tab].vue")
  }
]
  },
  {
    name: "OrderDetail",
    path: "/Order/Detail/:id()",
    meta: _91id_93I7fPXHF4bZubbuWkazO_gBgoqslGxPG3xlr9NYf1lyEMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Detail/[id].vue")
  },
  {
    name: "ProductsIndex",
    path: "/:category?",
    meta: indexIzVQ3GHwZC54k3XOO7RTsi9nV__Rr63x_F9mb_sHNygMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/[[category]]/index.vue")
  },
  {
    name: "OrderCreate",
    path: "/Order/Create",
    meta: indexXLqCkOMyLbwS2EAthiN3XnrH75STI824TD7z3qKcYFcMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Create/index.vue")
  },
  {
    name: "ProfileEdit",
    path: "/Profile/Edit",
    meta: { ...(indexeoS3Au7tNl4lCL_1qAbnYwrePbwWLYY4GL6oshPoAz8Meta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/User/pages/Profile/Edit/index.vue")
  },
  {
    name: "LoyaltyIndex",
    path: "/Profile/Loyalty",
    meta: { ...(indexJwQckVpGWxrI1rMkx5xLgulxHKW2VVEXexuKHJf_nwQMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Loyalty/pages/Profile/Loyalty/index.vue")
  },
  {
    name: "FavoritesIndex",
    path: "/Profile/Favorites",
    meta: { ...(indexyOgbI1hORu_m_ZUHYmProVUINWFJvDxFWFUjd4yXElsMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Favorites/pages/Profile/Favorites/index.vue")
  },
  {
    name: "OrderPaymentFail",
    path: "/Order/Payment/Fail",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Fail/index.vue")
  },
  {
    name: "ProductsCatalog",
    path: "/catalog/:category?",
    meta: indexLCm5rRrY1JEcCog13VXX8D5MJXObF2fsYZQBBK9ZNqYMeta || {},
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Products/pages/catalog/[[category]]/index.vue")
  },
  {
    name: "OrderPaymentSuccess",
    path: "/Order/Payment/Success",
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Order/pages/Order/Payment/Success/index.vue")
  },
  {
    name: "NotificationsIndex",
    path: "/Profile/Notifications",
    meta: { ...(indexJsVg1vY1vlIFlD_zWf9ash15FtT_ZFrM_cgYtaUROXkMeta || {}), ...{"middleware":"auth-scope"} },
    component: () => import("/builds/skuby/e-shop-template/projects/web/apps/web/app/AltApplication/Modules/Notifications/pages/Profile/Notifications/index.vue")
  }
]